module.exports = __webpack_public_path__ + "img/SES_400079459.da6899e0.jpg";